/**
 * lib/mixpanel.js — Mixpanel analytics integration.
 *
 * Follows the same isSupported() guard pattern as Firebase Analytics.
 * Never crashes if Mixpanel fails to load or token is missing.
 */

let mp = null;
let ready = false;

function init() {
  try {
    const token = process.env.REACT_APP_MIXPANEL_TOKEN;
    if (!token) return;
    const mixpanel = require("mixpanel-browser");
    mixpanel.init(token, {
      track_pageview: false,
      persistence: "localStorage",
      ignore_dnt: true,
    });
    mp = mixpanel;
    ready = true;
  } catch (e) {
    console.warn("Mixpanel init failed:", e);
  }
}

init();

export function isSupported() {
  return ready && mp !== null;
}

export function track(event, properties = {}) {
  if (!isSupported()) return;
  try {
    mp.track(event, properties);
  } catch {}
}

export function identify(userId, traits = {}) {
  if (!isSupported()) return;
  try {
    mp.identify(userId);
    if (Object.keys(traits).length > 0) {
      mp.people.set(traits);
    }
  } catch {}
}

export function reset() {
  if (!isSupported()) return;
  try {
    mp.reset();
  } catch {}
}
